<template>
	<div class="box">
		<div>
			<div class="numDoctor">
				<div class="text2">
					<p>昨日登录次数</p>
					<p>298</p>
				</div>
				<div class="text2">
					<p>昨日登录人数</p>
					<p>152</p>
				</div>
				<div class="text2">
					<p>昨日人均停留时长(min)</p>
					<p>24</p>
				</div>
				<div class="text2">
					<p>昨日生成报告数量(梳理报告)</p>
					<p>30</p>
				</div>
			</div>
			<div class="chartsDoc">
				<div class="chartsDocheader">
					<div>
						<el-date-picker
						    v-model="value1"
						    type="daterange"
						    range-separator="至"
						    start-placeholder="开始月份"
						    end-placeholder="结束月份"
						    value-format="yyyy-MM-dd"
						    @blur="date1Fn()">
						    </el-date-picker>
					</div>
					<div>
						<el-select v-model="ldvalue" placeholder="请选择">
						    <el-option
						      v-for="item in ldoption"
						      :key="item.id"
						      :label="item.name"
						      :value="item.id"
						      :change="yhrx_zcxzFn()">
						    </el-option>
						  </el-select>
					</div>
					<div class="datebtn">
						<div :class="btnStr==7?'active':''" @click="dayFn(7)">近7日</div>
						<div :class="btnStr==30?'active':''" @click="dayFn(30)">近30日</div>
					</div>
				</div>
				<div class="chartsDoccontent">
					<div>
						<charts :type="1" :options="options1" :dates="value1" :datazc="dlrs" :datazs="dlcs" :datafb="dlzs" :datafb1="bgzs"></charts>
					</div>
					<div>
						<charts :type="2" :options="options1" :dates="value1" :datazc="dlrs" :datazs="dlcs" :datafb="dlzs" :datafb1="bgzs"></charts>
					</div>
				</div>
			</div>
		</div>
		<div>
			<div class="numDoctor">
				
			</div>
			<div class="chartsDoc">
				<div class="chartsDocheader">
					
				</div>
				<div class="chartsDoccontent">
					<div>
						<charts :type="1" :options="options2" :dates="value1" :datazs="tlsc"></charts>
					</div>
					<div>
						<charts :type="1" :options="options3" :dates="value1" :datazs="bgsc"></charts>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import {user_count,yhrx_zcxz,pdm_tj} from '../components/http/api.js'
	import {datagk} from './../assets/js/sygk.js'
	import charts from '../component/charts.vue'
	export default{
		components:{
			charts
		},
		data(){
			return{
				gkdata:datagk,
				value1:[],
				value2:[],
				btnStr:7,
				btn1Str:7,
				options1:[{
					id:1,
					name:'登陆次数',
				},{
					id:2,
					name:'登陆人数',
				},{
					id:3,
					name:'累计登陆人数',
				},{
					id:4,
					name:'累计生成报告总数',
				}],
				options2:[{
					id:1,
					name:'人均停留时长(min)',
				}],
				options3:[{
					id:1,
					name:'报告生成数量',
				}],
				dlrs:{
		            title: {
//		                text: 'Biu~简单柱状图示例'
		            },
		            tooltip: {},
		            axisPointer: {            // 坐标轴指示器，坐标轴触发有效
			            type: 'shadow'        // 默认为直线，可选为：'line' | 'shadow'
			        },
		            legend: {
		            	top:20
//		                data:['人数']
		            },
		            xAxis: {
		            	type: 'category',
		                data: [0,0,0,0]
		            },
		            yAxis: {
		            	type: 'value'
		            },
		            series: [{
		                name: '人数',
		                type: 'bar',
		                data: [0,0,0,0]
		            }],
		            color: ['rgba(29,181,255,1)']
		        },
				dlcs:{
		            title: {
//		                text: 'Biu~简单柱状图示例'
		            },
		            tooltip: {},
		            axisPointer: {            // 坐标轴指示器，坐标轴触发有效
			            type: 'shadow'        // 默认为直线，可选为：'line' | 'shadow'
			        },
		            legend: {
		            	top:20
//		                data:['人数']
		            },
		            xAxis: {
		            	type: 'category',
		               	data: [0,0,0,0]
		            },
		            yAxis: {
		            	type: 'value'
		            },
		            series: [{
		                name: '次数',
		                type: 'bar',
		                data: [0,0,0,0]
		            }],
		            color: ['rgba(29,181,255,1)','#aaaaaa']
		        },
		        rzxz:{
		            title: {
//		                text: 'Biu~简单柱状图示例'
		            },
		            tooltip: {},
		            axisPointer: {            // 坐标轴指示器，坐标轴触发有效
			            type: 'shadow'        // 默认为直线，可选为：'line' | 'shadow'
			        },
		            legend: {
		            	top:20
//		                data:['人数']
		            },
		            xAxis: {
		            	type: 'category',
		                data: [0,0,0,0]
		            },
		            yAxis: {
		            	type: 'value'
		            },
		            series: [{
		                name: '人数',
		                type: 'bar',
		                data: [0,0,0,0]
		            }],
		            color: ['rgba(29,181,255,1)']
		        },
		         tlsc:{
		            title: {
//		                text: 'Biu~简单柱状图示例'
		            },
		            tooltip: {},
		            axisPointer: {            // 坐标轴指示器，坐标轴触发有效
			            type: 'shadow'        // 默认为直线，可选为：'line' | 'shadow'
			        },
		            legend: {
		            	top:20
//		                data:['人数']
		            },
		            xAxis: {
		            	type: 'category',
		                data: [0,0,0,0]
		            },
		            yAxis: {
		            	type: 'value'
		            },
		            series: [{
		                name: '人数',
		                type: 'bar',
		                data: [0,0,0,0]
		            }],
		            color: ['rgba(29,181,255,1)']
		        },
		        bgsc:{
		            title: {
//		                text: 'Biu~简单柱状图示例'
		            },
		            tooltip: {},
		            axisPointer: {            // 坐标轴指示器，坐标轴触发有效
			            type: 'shadow'        // 默认为直线，可选为：'line' | 'shadow'
			        },
		            legend: {
		            	top:20
//		                data:['人数']
		            },
		            xAxis: {
		            	type: 'category',
		               	data: [0,0,0,0]
		            },
		            yAxis: {
		            	type: 'value'
		            },
		            series: [{
		                name: '梳理报告',
		                type: 'bar',
		                data: [0,0,0,0]
		            },{
		                name: '沟通报告',
		                type: 'bar',
		                data: [0,0,0,0]
		            }],
		            color: ['rgba(29,181,255,1)','#aaaaaa']
		        },
				dlzs:{
		            title: {
//		                text: 'Biu~简单柱状图示例'
		            },
		            tooltip: {},
		            axisPointer: {            // 坐标轴指示器，坐标轴触发有效
			            type: 'shadow'        // 默认为直线，可选为：'line' | 'shadow'
			        },
		            legend: {
		            	top:20
//		                data:['人数']
		            },
		            xAxis: {
		            	type: 'category',
		               	data: [0,0,0,0]
		            },
		            yAxis: {
		            	type: 'value'
		            },
		            series: [{
		                name: '人数',
		                type: 'line',
		                data: [0,0,0,0]
		            }],
		            color: ['rgba(29,181,255,1)','#aaaaaa']
		        },
		        bgzs:{
		            title: {
//		                text: 'Biu~简单柱状图示例'
		            },
		            tooltip: {},
		            axisPointer: {            // 坐标轴指示器，坐标轴触发有效
			            type: 'shadow'        // 默认为直线，可选为：'line' | 'shadow'
			        },
		            legend: {
		            	top:20
//		                data:['人数']
		            },
		            xAxis: {
		            	type: 'category',
		               	data: [0,0,0,0]
		            },
		            yAxis: {
		            	type: 'value'
		            },
		            series: [{
		                name: '报告数量',
		                type: 'line',
		                data: [0,0,0,0]
		            }],
		            color: ['rgba(29,181,255,1)','#aaaaaa']
		        },
				ldvalue:1,
				ldoption:[{
					id:1,
					name:'日粒度'
				},{
					id:2,
					name:'周粒度'
				},{
					id:3,
					name:'月粒度'
				}]
			}
		},
		beforeMount() {
			this.user_countFn();
		},
		mounted() {
			this.value1=[this.getDay(-7),this.getDay(-1)];
			this.yhrx_zcxzFn();
		},
		methods:{
			user_countFn(){
				user_count().then(res=>{
					for(var i=0;i<res.list.length;i++){
					}
				})
			},
			getDay(day){
			    var today = new Date();
			    var targetday_milliseconds=today.getTime() + 1000*60*60*24*day;
			    today.setTime(targetday_milliseconds); //注意，这行是关键代码
			    var tYear = today.getFullYear();
			    var tMonth = today.getMonth();
			    var tDate = today.getDate();
			    tMonth = this.doHandleMonth(tMonth + 1);
			    tDate = this.doHandleMonth(tDate);
			    return tYear+"-"+tMonth+"-"+tDate;
			},
			doHandleMonth(month){
			    var m = month;
			    if(month.toString().length == 1){
			     m = "0" + month;
			    }
			    return m;
			},
			dayFn(i){
				this.btnStr=i;
				this.value1=[this.getDay(-i),this.getDay(-1)];
				this.yhrx_zcxzFn();
//				this.yhrx_zczsFn();
			},
			yhrx_zcxzFn(){
				var data={
					start_time:this.value1[0],
					end_time:this.value1[1]
				}
				yhrx_zcxz (data).then(res=>{
					if(this.ldvalue==1){
						var arr1=res.ay_time;
						var arr2=this.gkdata.dlrsarr.slice((this.gkdata.dlrsarr.length-1)-(arr1.length-1),this.gkdata.bgscslarr.length);
						var arr3=this.gkdata.dlcsarr.slice((this.gkdata.dlcsarr.length-1)-(arr1.length-1),this.gkdata.bgscslarr.length);
						var arr4=this.gkdata.tlscarr.slice((this.gkdata.tlscarr.length-1)-(arr1.length-1),this.gkdata.bgscslarr.length);
						var arr5=this.gkdata.bgscslarr.slice((this.gkdata.bgscslarr.length-1)-(arr1.length-1),this.gkdata.bgscslarr.length);
					}else if(this.ldvalue==2){
						if(this.btnStr==7){
							var arr1=this.gkdata.zldatearr.slice(7,8);
							var arr2=this.gkdata.zlddlrsarr.slice(7,8);
							var arr3=this.gkdata.zlddlcsarr.slice(7,8);
							var arr4=this.gkdata.zltlscarr.slice(7,8);
							var arr5=this.gkdata.zlbgscslarr.slice(7,8);
						}else if(this.btnStr==30){
							var arr1=this.gkdata.zldatearr.slice(4,8);
							var arr2=this.gkdata.zlddlrsarr.slice(4,8);
							var arr3=this.gkdata.zlddlcsarr.slice(4,8);
							var arr4=this.gkdata.zltlscarr.slice(4,8);
							var arr5=this.gkdata.zlbgscslarr.slice(4,8);
						}
						
					}else if(this.ldvalue==3){
						if(this.btnStr==7){
							var arr1=this.gkdata.yldatearr;
							var arr2=this.gkdata.ylddlrsarr;
							var arr3=this.gkdata.ylddlcsarr;
							var arr4=this.gkdata.yltlscarr;
							var arr5=this.gkdata.ylbgscslarr;
						}else if(this.btnStr==30){
							var arr1=this.gkdata.yldatearr;
							var arr2=this.gkdata.ylddlrsarr;
							var arr3=this.gkdata.ylddlcsarr;
							var arr4=this.gkdata.yltlscarr;
							var arr5=this.gkdata.ylbgscslarr;
						}
					}
//					var arr1s=["06-22", "06-23", "06-24", "06-25", "06-26", "06-27", "06-28"];
//					var arr2s=[1,0,1,2,0,2,1];

					this.dlrs.xAxis.data=arr1;
					this.dlrs.series[0].data=arr2;
					this.dlcs.xAxis.data=arr1;
					this.dlcs.series[0].data=arr3;
					this.tlsc.xAxis.data=arr1;
					this.tlsc.series[0].data=arr4;
					this.bgsc.xAxis.data=arr1;
					this.bgsc.series[0].data=arr5;
					
				})
			},
		}
	}
</script>

<style scoped>
	.box{
		width: 100%;
		height: 100%;
	}
	.box>div{
		height: 364px;
		width: 100%;
		display: flex;
		justify-content: space-between;
		/*background: #FFFFFF;*/
	}
	
	.box>div:nth-child(1){
	}
	.numDoctor{
		width: 212px;
		height: 344px;
		padding:10px 20px;
		border-radius:3px;
		/*border-right: 3px solid rgba(198,198,198,1);*/
		background: #FFFFFF;
	}
	.text1,.text2{
		margin-bottom: 30px;
	}
	.text1>p:nth-child(1){
		font-size:15px;
		font-weight:400;
		color:rgba(74,74,74,1);
		line-height:23px;
	}
	.text1>p:nth-child(2){
		font-size:30px;
		font-weight:600;
		color:rgba(74,74,74,1);
		margin-top: 8px;
		line-height:23px;
	}
	.text2>p:nth-child(1){
		font-size:15px;
		font-weight:400;
		color:rgba(74,74,74,1);
		line-height:23px;
	}
	.text2>p:nth-child(2){
		margin-top: 8px;
		font-size:30px;
		font-weight:600;
		color:rgba(29,181,255,1);
		line-height:23px;
	}
	.chartsDoc{
		width:1035px;
		height:344px;
		padding: 10px 20px;
		background:rgba(255,255,255,1);
		border-radius:3px;
		
	}
	.chartsDocheader{
		display: flex;
		justify-content: space-between;
		align-items: center;
	}
	.chartsDocheader>div:nth-child(1){
		width: 400px;
	}
	.chartsDocheader>div:nth-child(1)>div{
		width: 400px;
	}
	.datebtn>div:hover{
		border:1px solid yellow;
		
	}
	.datebtn{
		display: flex;
	}
	.datebtn>div{
		margin-right: 13px;
		cursor: pointer;
		width:93px;
		height:42px;
		background:rgba(234,234,234,1);
		border-radius:24px;
		border:1px solid rgba(221,227,232,1);
		font-size:19px;
		font-family:PingFangSC-Medium,PingFang SC;
		font-weight:500;
		color:rgba(155,155,155,1);
		line-height:24px;
		display: flex;justify-content: center;
		align-items: center;
	}
	.datebtn>div.active{
		font-size:19px;
		font-family:PingFangSC-Medium,PingFang SC;
		font-weight:500;
		color:rgba(255,255,255,1);
		line-height:24px;
		background:rgba(29,181,255,1);
	}
	.chartsDoccontent{
		display: flex;
		justify-content: space-between;
	}
	.chartsDoccontent>div{
		width:497px;
		height: 290px;
		margin-top: 10px;
		/*background: #CCCCCC;*/
	}
	
</style>


// WEBPACK FOOTER //
// src/component/exEchart.vue